/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { CoreBaseService } from '../core-base-service';
import { CoreApiConfiguration } from '../core-api-configuration';
import { CoreStrictHttpResponse } from '../core-strict-http-response';

import { CoreProjectTaskLightResponseDto } from '../models/core-project-task-light-response-dto';
import { CoreProjectTaskResponseDto } from '../models/core-project-task-response-dto';
import { projectTasksControllerBatchCreateWithSubtasks } from '../fn/project-tasks/project-tasks-controller-batch-create-with-subtasks';
import { ProjectTasksControllerBatchCreateWithSubtasks$Params } from '../fn/project-tasks/project-tasks-controller-batch-create-with-subtasks';
import { projectTasksControllerCreate } from '../fn/project-tasks/project-tasks-controller-create';
import { ProjectTasksControllerCreate$Params } from '../fn/project-tasks/project-tasks-controller-create';
import { projectTasksControllerDelete } from '../fn/project-tasks/project-tasks-controller-delete';
import { ProjectTasksControllerDelete$Params } from '../fn/project-tasks/project-tasks-controller-delete';
import { projectTasksControllerFindAllByTenant } from '../fn/project-tasks/project-tasks-controller-find-all-by-tenant';
import { ProjectTasksControllerFindAllByTenant$Params } from '../fn/project-tasks/project-tasks-controller-find-all-by-tenant';
import { projectTasksControllerFindByProjectAndDate } from '../fn/project-tasks/project-tasks-controller-find-by-project-and-date';
import { ProjectTasksControllerFindByProjectAndDate$Params } from '../fn/project-tasks/project-tasks-controller-find-by-project-and-date';
import { projectTasksControllerFindByProjectId } from '../fn/project-tasks/project-tasks-controller-find-by-project-id';
import { ProjectTasksControllerFindByProjectId$Params } from '../fn/project-tasks/project-tasks-controller-find-by-project-id';
import { projectTasksControllerFindCompleteByProjectId } from '../fn/project-tasks/project-tasks-controller-find-complete-by-project-id';
import { ProjectTasksControllerFindCompleteByProjectId$Params } from '../fn/project-tasks/project-tasks-controller-find-complete-by-project-id';
import { projectTasksControllerFindLightByTenant } from '../fn/project-tasks/project-tasks-controller-find-light-by-tenant';
import { ProjectTasksControllerFindLightByTenant$Params } from '../fn/project-tasks/project-tasks-controller-find-light-by-tenant';
import { projectTasksControllerFindOne } from '../fn/project-tasks/project-tasks-controller-find-one';
import { ProjectTasksControllerFindOne$Params } from '../fn/project-tasks/project-tasks-controller-find-one';
import { projectTasksControllerFindOneComplete } from '../fn/project-tasks/project-tasks-controller-find-one-complete';
import { ProjectTasksControllerFindOneComplete$Params } from '../fn/project-tasks/project-tasks-controller-find-one-complete';
import { projectTasksControllerGetVacationMetrics } from '../fn/project-tasks/project-tasks-controller-get-vacation-metrics';
import { ProjectTasksControllerGetVacationMetrics$Params } from '../fn/project-tasks/project-tasks-controller-get-vacation-metrics';
import { projectTasksControllerUpdate } from '../fn/project-tasks/project-tasks-controller-update';
import { ProjectTasksControllerUpdate$Params } from '../fn/project-tasks/project-tasks-controller-update';
import { projectTasksControllerUpdateByProjectId } from '../fn/project-tasks/project-tasks-controller-update-by-project-id';
import { ProjectTasksControllerUpdateByProjectId$Params } from '../fn/project-tasks/project-tasks-controller-update-by-project-id';
import { CoreProjectTaskWithSubtasksResponseDto } from '../models/core-project-task-with-subtasks-response-dto';
import { CoreVacationMetricsResponseDto } from '../models/core-vacation-metrics-response-dto';

@Injectable({ providedIn: 'root' })
export class CoreProjectTasksService extends CoreBaseService {
  constructor(config: CoreApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `projectTasksControllerBatchCreateWithSubtasks()` */
  static readonly ProjectTasksControllerBatchCreateWithSubtasksPath = '/o2-core/project-tasks/{tenant}/batch';

  /**
   * Batch create project tasks with subtasks.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectTasksControllerBatchCreateWithSubtasks()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectTasksControllerBatchCreateWithSubtasks$Response(params: ProjectTasksControllerBatchCreateWithSubtasks$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<Array<CoreProjectTaskWithSubtasksResponseDto>>> {
    const obs = projectTasksControllerBatchCreateWithSubtasks(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Batch create project tasks with subtasks.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectTasksControllerBatchCreateWithSubtasks$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectTasksControllerBatchCreateWithSubtasks(params: ProjectTasksControllerBatchCreateWithSubtasks$Params, context?: HttpContext): Observable<Array<CoreProjectTaskWithSubtasksResponseDto>> {
    const resp = this.projectTasksControllerBatchCreateWithSubtasks$Response(params, context);
    return resp.pipe(
      map((r: CoreStrictHttpResponse<Array<CoreProjectTaskWithSubtasksResponseDto>>): Array<CoreProjectTaskWithSubtasksResponseDto> => r.body)
    );
  }

  /** Path part for operation `projectTasksControllerFindAllByTenant()` */
  static readonly ProjectTasksControllerFindAllByTenantPath = '/o2-core/project-tasks/{tenant}';

  /**
   * Retrieve all project tasks by tenant.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectTasksControllerFindAllByTenant()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectTasksControllerFindAllByTenant$Response(params: ProjectTasksControllerFindAllByTenant$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<Array<CoreProjectTaskResponseDto>>> {
    const obs = projectTasksControllerFindAllByTenant(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve all project tasks by tenant.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectTasksControllerFindAllByTenant$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectTasksControllerFindAllByTenant(params: ProjectTasksControllerFindAllByTenant$Params, context?: HttpContext): Observable<Array<CoreProjectTaskResponseDto>> {
    const resp = this.projectTasksControllerFindAllByTenant$Response(params, context);
    return resp.pipe(
      map((r: CoreStrictHttpResponse<Array<CoreProjectTaskResponseDto>>): Array<CoreProjectTaskResponseDto> => r.body)
    );
  }

  /** Path part for operation `projectTasksControllerCreate()` */
  static readonly ProjectTasksControllerCreatePath = '/o2-core/project-tasks/{tenant}';

  /**
   * Create a new project task.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectTasksControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectTasksControllerCreate$Response(params: ProjectTasksControllerCreate$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<CoreProjectTaskResponseDto>> {
    const obs = projectTasksControllerCreate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create a new project task.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectTasksControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectTasksControllerCreate(params: ProjectTasksControllerCreate$Params, context?: HttpContext): Observable<CoreProjectTaskResponseDto> {
    const resp = this.projectTasksControllerCreate$Response(params, context);
    return resp.pipe(
      map((r: CoreStrictHttpResponse<CoreProjectTaskResponseDto>): CoreProjectTaskResponseDto => r.body)
    );
  }

  /** Path part for operation `projectTasksControllerFindOne()` */
  static readonly ProjectTasksControllerFindOnePath = '/o2-core/project-tasks/{tenant}/{id}';

  /**
   * Retrieve a project task by ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectTasksControllerFindOne()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectTasksControllerFindOne$Response(params: ProjectTasksControllerFindOne$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<CoreProjectTaskResponseDto>> {
    const obs = projectTasksControllerFindOne(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve a project task by ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectTasksControllerFindOne$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectTasksControllerFindOne(params: ProjectTasksControllerFindOne$Params, context?: HttpContext): Observable<CoreProjectTaskResponseDto> {
    const resp = this.projectTasksControllerFindOne$Response(params, context);
    return resp.pipe(
      map((r: CoreStrictHttpResponse<CoreProjectTaskResponseDto>): CoreProjectTaskResponseDto => r.body)
    );
  }

  /** Path part for operation `projectTasksControllerDelete()` */
  static readonly ProjectTasksControllerDeletePath = '/o2-core/project-tasks/{tenant}/{id}';

  /**
   * Delete a project task by ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectTasksControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectTasksControllerDelete$Response(params: ProjectTasksControllerDelete$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<CoreProjectTaskResponseDto>> {
    const obs = projectTasksControllerDelete(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Delete a project task by ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectTasksControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectTasksControllerDelete(params: ProjectTasksControllerDelete$Params, context?: HttpContext): Observable<CoreProjectTaskResponseDto> {
    const resp = this.projectTasksControllerDelete$Response(params, context);
    return resp.pipe(
      map((r: CoreStrictHttpResponse<CoreProjectTaskResponseDto>): CoreProjectTaskResponseDto => r.body)
    );
  }

  /** Path part for operation `projectTasksControllerUpdate()` */
  static readonly ProjectTasksControllerUpdatePath = '/o2-core/project-tasks/{tenant}/{id}';

  /**
   * Update a project task by ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectTasksControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectTasksControllerUpdate$Response(params: ProjectTasksControllerUpdate$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<CoreProjectTaskResponseDto>> {
    const obs = projectTasksControllerUpdate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Update a project task by ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectTasksControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectTasksControllerUpdate(params: ProjectTasksControllerUpdate$Params, context?: HttpContext): Observable<CoreProjectTaskResponseDto> {
    const resp = this.projectTasksControllerUpdate$Response(params, context);
    return resp.pipe(
      map((r: CoreStrictHttpResponse<CoreProjectTaskResponseDto>): CoreProjectTaskResponseDto => r.body)
    );
  }

  /** Path part for operation `projectTasksControllerUpdateByProjectId()` */
  static readonly ProjectTasksControllerUpdateByProjectIdPath = '/o2-core/project-tasks/{tenant}/project/{projectId}';

  /**
   * Update all project tasks by project ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectTasksControllerUpdateByProjectId()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectTasksControllerUpdateByProjectId$Response(params: ProjectTasksControllerUpdateByProjectId$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<void>> {
    const obs = projectTasksControllerUpdateByProjectId(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Update all project tasks by project ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectTasksControllerUpdateByProjectId$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectTasksControllerUpdateByProjectId(params: ProjectTasksControllerUpdateByProjectId$Params, context?: HttpContext): Observable<void> {
    const resp = this.projectTasksControllerUpdateByProjectId$Response(params, context);
    return resp.pipe(
      map((r: CoreStrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `projectTasksControllerFindLightByTenant()` */
  static readonly ProjectTasksControllerFindLightByTenantPath = '/o2-core/project-tasks/{tenant}/light';

  /**
   * Retrieve light project tasks for a tenant (for autocomplete).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectTasksControllerFindLightByTenant()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectTasksControllerFindLightByTenant$Response(params: ProjectTasksControllerFindLightByTenant$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<Array<CoreProjectTaskLightResponseDto>>> {
    const obs = projectTasksControllerFindLightByTenant(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve light project tasks for a tenant (for autocomplete).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectTasksControllerFindLightByTenant$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectTasksControllerFindLightByTenant(params: ProjectTasksControllerFindLightByTenant$Params, context?: HttpContext): Observable<Array<CoreProjectTaskLightResponseDto>> {
    const resp = this.projectTasksControllerFindLightByTenant$Response(params, context);
    return resp.pipe(
      map((r: CoreStrictHttpResponse<Array<CoreProjectTaskLightResponseDto>>): Array<CoreProjectTaskLightResponseDto> => r.body)
    );
  }

  /** Path part for operation `projectTasksControllerFindByProjectId()` */
  static readonly ProjectTasksControllerFindByProjectIdPath = '/o2-core/project-tasks/{tenant}/project/{projectId}/tasks';

  /**
   * Retrieve all project tasks for a specific project.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectTasksControllerFindByProjectId()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectTasksControllerFindByProjectId$Response(params: ProjectTasksControllerFindByProjectId$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<Array<CoreProjectTaskResponseDto>>> {
    const obs = projectTasksControllerFindByProjectId(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve all project tasks for a specific project.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectTasksControllerFindByProjectId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectTasksControllerFindByProjectId(params: ProjectTasksControllerFindByProjectId$Params, context?: HttpContext): Observable<Array<CoreProjectTaskResponseDto>> {
    const resp = this.projectTasksControllerFindByProjectId$Response(params, context);
    return resp.pipe(
      map((r: CoreStrictHttpResponse<Array<CoreProjectTaskResponseDto>>): Array<CoreProjectTaskResponseDto> => r.body)
    );
  }

  /** Path part for operation `projectTasksControllerFindCompleteByProjectId()` */
  static readonly ProjectTasksControllerFindCompleteByProjectIdPath = '/o2-core/project-tasks/{tenant}/project/{projectId}/complete';

  /**
   * Retrieve all project tasks with subtasks for a specific project (batch efficient).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectTasksControllerFindCompleteByProjectId()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectTasksControllerFindCompleteByProjectId$Response(params: ProjectTasksControllerFindCompleteByProjectId$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<Array<CoreProjectTaskWithSubtasksResponseDto>>> {
    const obs = projectTasksControllerFindCompleteByProjectId(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve all project tasks with subtasks for a specific project (batch efficient).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectTasksControllerFindCompleteByProjectId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectTasksControllerFindCompleteByProjectId(params: ProjectTasksControllerFindCompleteByProjectId$Params, context?: HttpContext): Observable<Array<CoreProjectTaskWithSubtasksResponseDto>> {
    const resp = this.projectTasksControllerFindCompleteByProjectId$Response(params, context);
    return resp.pipe(
      map((r: CoreStrictHttpResponse<Array<CoreProjectTaskWithSubtasksResponseDto>>): Array<CoreProjectTaskWithSubtasksResponseDto> => r.body)
    );
  }

  /** Path part for operation `projectTasksControllerFindOneComplete()` */
  static readonly ProjectTasksControllerFindOneCompletePath = '/o2-core/project-tasks/{tenant}/{id}/complete';

  /**
   * Retrieve a project task with its subtasks by ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectTasksControllerFindOneComplete()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectTasksControllerFindOneComplete$Response(params: ProjectTasksControllerFindOneComplete$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<CoreProjectTaskWithSubtasksResponseDto>> {
    const obs = projectTasksControllerFindOneComplete(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve a project task with its subtasks by ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectTasksControllerFindOneComplete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectTasksControllerFindOneComplete(params: ProjectTasksControllerFindOneComplete$Params, context?: HttpContext): Observable<CoreProjectTaskWithSubtasksResponseDto> {
    const resp = this.projectTasksControllerFindOneComplete$Response(params, context);
    return resp.pipe(
      map((r: CoreStrictHttpResponse<CoreProjectTaskWithSubtasksResponseDto>): CoreProjectTaskWithSubtasksResponseDto => r.body)
    );
  }

  /** Path part for operation `projectTasksControllerFindByProjectAndDate()` */
  static readonly ProjectTasksControllerFindByProjectAndDatePath = '/o2-core/project-tasks/{tenant}/project/{projectId}/by-date';

  /**
   * Retrieve all project tasks for a specific project and date range (for sprint planning).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectTasksControllerFindByProjectAndDate()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectTasksControllerFindByProjectAndDate$Response(params: ProjectTasksControllerFindByProjectAndDate$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<Array<CoreProjectTaskResponseDto>>> {
    const obs = projectTasksControllerFindByProjectAndDate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve all project tasks for a specific project and date range (for sprint planning).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectTasksControllerFindByProjectAndDate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectTasksControllerFindByProjectAndDate(params: ProjectTasksControllerFindByProjectAndDate$Params, context?: HttpContext): Observable<Array<CoreProjectTaskResponseDto>> {
    const resp = this.projectTasksControllerFindByProjectAndDate$Response(params, context);
    return resp.pipe(
      map((r: CoreStrictHttpResponse<Array<CoreProjectTaskResponseDto>>): Array<CoreProjectTaskResponseDto> => r.body)
    );
  }

  /** Path part for operation `projectTasksControllerGetVacationMetrics()` */
  static readonly ProjectTasksControllerGetVacationMetricsPath = '/o2-core/project-tasks/{tenant}/{id}/metrics';

  /**
   * Vacation (T&M) metrics for a project task.
   *
   * Aggregates the task timesheets by snapshotLevel to return value, cost and margin. Returns zero buckets for non-vacation tasks.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectTasksControllerGetVacationMetrics()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectTasksControllerGetVacationMetrics$Response(params: ProjectTasksControllerGetVacationMetrics$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<CoreVacationMetricsResponseDto>> {
    const obs = projectTasksControllerGetVacationMetrics(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Vacation (T&M) metrics for a project task.
   *
   * Aggregates the task timesheets by snapshotLevel to return value, cost and margin. Returns zero buckets for non-vacation tasks.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectTasksControllerGetVacationMetrics$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectTasksControllerGetVacationMetrics(params: ProjectTasksControllerGetVacationMetrics$Params, context?: HttpContext): Observable<CoreVacationMetricsResponseDto> {
    const resp = this.projectTasksControllerGetVacationMetrics$Response(params, context);
    return resp.pipe(
      map((r: CoreStrictHttpResponse<CoreVacationMetricsResponseDto>): CoreVacationMetricsResponseDto => r.body)
    );
  }

}
